export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-20 pb-12 md:pb-0 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/30"></div>

      <div className="relative w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 xl:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              <span className="whitespace-nowrap">2025 暑期档热播中</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-heading font-bold text-foreground-950 leading-tight tracking-tight">
              牛牛影视
              <br />
              <span className="text-primary-500">海量影视一站畅享</span>
            </h1>

            <p className="mt-5 md:mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              覆盖热门电影、高清电视剧、爆笑综艺和动漫番剧，每日 24 小时不间断更新最新影视资源。无论是国产热播剧、海外大片还是经典老片，牛牛影视为你打造随时随地的高清观影体验。2025 暑期档片单已全面上线，一起开启追剧模式。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-6">
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-film-line text-primary-500 text-base"></i>
                <span><strong className="text-foreground-700">10 万+</strong> 影视资源</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-user-smile-line text-accent-500 text-base"></i>
                <span><strong className="text-foreground-700">5000 万+</strong> 月活用户</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-timer-flash-line text-primary-500 text-base"></i>
                <span>每日 <strong className="text-foreground-700">24h</strong> 持续更新</span>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-7 py-3 border border-background-300/60 hover:border-primary-400 hover:text-primary-500 text-foreground-700 font-medium text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-medal-line text-lg"></i>
                热播榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-xl overflow-hidden aspect-[4/3] lg:aspect-[5/4]">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20warm%20theater%20spotlight%20and%20film%20strip%20borders%2C%20golden%20and%20deep%20red%20tones%2C%20elegant%20cinema%20atmosphere%2C%20dramatic%20lighting%20on%20red%20velvet%20curtains%2C%20classic%20movie%20palace%20interior%20with%20warm%20glow%2C%20art%20deco%20details%2C%20nostalgic%20film%20aesthetic&width=1200&height=900&seq=hero-main-x9&orientation=landscape"
                alt="牛牛影视 - 海量影视一站式畅享"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-black/20 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5 bg-gradient-to-t from-black/60 to-transparent">
                <div className="flex items-center gap-3">
                  <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
                  <span className="text-xs text-white/90 font-medium whitespace-nowrap">热播中：庆余年 第二季</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}